import { ca } from '@cian/analytics';

interface ITrackNavigationToCard {
  id: number;
}

export function trackNavigationToCard({ id }: ITrackNavigationToCard) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'to_card',
    products: [{ id }],
  });
}

export function trackOfferTeaserShow({ offerId, position }: { offerId: number; position: number }) {
  ca('teaser', {
    product: {
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
      },
      position: position + 1,
      screen: 'CompareScreen',
      block: 'Compare',
    },
  });
}
